module.exports = __webpack_public_path__ + "img/smartphone.790ef6a5.svg";